import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetLocation } from '../../../../state';

const BuildingEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetLocation({ building: event.target.value }));
  };

  return (
    <TextField
      label="Building"
      size="small"
      fullWidth
      value={currentAsset?.building || ''}
      onChange={handleChange}
    />
  );
};

export default BuildingEdit;
